import React from 'react';
import { connect } from 'react-redux';
import { Routes, Route, useMatch } from 'react-router-dom';

import HeadingBlock from '$/components/global/heading';
import HeadTab from '$/components/global/headingTab';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import { getIsCurrentUserBixbyComplianceAdminState, getIsSelectedUserClientState } from '$/store/profile/selectors';
import { setCurrentUser } from '$/store/user/actions';
import UserAccess from './UserAccess';
import UserProfile from './UserProfile';
import './index.scss';
import { getBixbyComplianceFeatureFlagState } from '$/store/release-feature-flags/selectors';

interface IUserDetailProps {
  currentUser?: Bixby.Models.User;
  isClient: boolean;
  isLoading: boolean;
  dispatchSetUser: (user: Bixby.Models.UserSlim) => Promise<void>;
  dispatchSetCurrentClient: (clientSlim?: Bixby.Models.ClientSlim) => Promise<void>;
  isBixbyComplianceAdmin: boolean;
  isBixbyComplianceEnabled: boolean;
}

const UserDetail: React.FC<IUserDetailProps> = props => {
  const { currentUser, isClient, dispatchSetUser, isBixbyComplianceAdmin, isBixbyComplianceEnabled } = props;
  const match = useMatch('/admin/user/:userId/*');

  if (Bixby.Utils.isNullOrEmpty(currentUser) && match) {
    const userSlim = {
      id: match.params.userId,
      client_Id: '',
      client_Name: '',
      firstName: '',
      lastName: '',
    } as Bixby.Models.UserSlim;
    dispatchSetUser(userSlim);
  }

  const baseUrl = `/admin/user/${match?.params.userId}`;
  const caUrl = `${baseUrl}/company-access`;

  const handlePublishClick = () => {
    return;
  };
  const handleCancelClick = () => {
    return;
  };

  const hasCompliancePermissions = () => {
    if (isBixbyComplianceEnabled) {
      return isBixbyComplianceAdmin;
    }
    return true;
  };

  const publishProps = {
    publishEnabled: false,
    enabled: false,
    seeAllLink: '/admin/user',
    onPublishClick: handlePublishClick,
    onCancelClick: handleCancelClick,
    onEditClick: () => void 0, // TODO: implement this
  };

  return currentUser ? (
    <React.Fragment>
      <section>
        <HeadingBlock title={`${currentUser.firstName} ${currentUser.lastName}`} publishButton={publishProps}>
          <HeadTab title="Account &amp; Profile" link={baseUrl} exact={true} />
          {isClient && hasCompliancePermissions() && <HeadTab title="Company Access" link={caUrl} exact={true} />}
        </HeadingBlock>
        <div>
          <Routes>
            <Route path={'/*'} element={<UserProfile />} />
            {isClient && hasCompliancePermissions() && <Route path={'/company-access'} element={<UserAccess />} />}
          </Routes>
        </div>
      </section>
    </React.Fragment>
  ) : null;
};

const mapStateToProps = (state: AppState) => {
  const { isClient } = getIsSelectedUserClientState(state);
  const { isBixbyComplianceAdmin } = getIsCurrentUserBixbyComplianceAdminState(state);
  const { isBixbyComplianceEnabled } = getBixbyComplianceFeatureFlagState(state);
  return {
    currentUser: state.userState.currentUser,
    isClient,
    isLoading: state.userState.isLoading,
    isBixbyComplianceAdmin,
    isBixbyComplianceEnabled,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchSetUser: (user: Bixby.Models.UserSlim) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
